import React, { useEffect, useState } from "react";
import {
  DataGrid,
  GridColDef,
  GridToolbarExport,
  koKR,
  GridToolbarContainer,
  GridToolbarFilterButton,
  GridToolbarColumnsButton,
  GridToolbarQuickFilter,
  GridFooterContainer,
  GridPreProcessEditCellProps,
} from "@mui/x-data-grid";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import axios from "axios";
import { koKR as corekoKR } from "@mui/material/locale";
import { Box, Typography } from "@mui/material";
import CustomPagination from "../../component/common/CustomPagination";
import { koKRGrid } from "../../component/common/TableKRText";
import api from "../../../API";
import { useSelector } from "react-redux";

function validateEmail(email: string) {
  const re =
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(String(email).toLowerCase());
}

function validatephone(phone: string) {
  const re = /^\(?(\d{3})\)?[- ]?(\d{4})[- ]?(\d{4})$/;
  return re.test(String(phone).toLowerCase());
}

function CustomToolbar(props: any) {
  return (
    <GridToolbarContainer>
      <GridToolbarColumnsButton />
      <GridToolbarFilterButton />
      <GridToolbarExport
        csvOptions={{
          utf8WithBom: true,
        }}
      />
      <GridToolbarQuickFilter sx={{ marginLeft: "auto" }} />
    </GridToolbarContainer>
  );
}

const columns: GridColDef[] = [
  { field: "idx", headerName: "id", width: 70 },
  { field: "company", headerName: "기관명", width: 100, editable: false },
  { field: "name", headerName: "성명", width: 100, editable: false },
  { field: "email", headerName: "이메일", width: 100, editable: false },
  {
    field: "jumin7",
    headerName: "주민번호(앞7자리)",
    width: 100,
    editable: false,
  },
  { field: "pay_type", headerName: "인건비 구분", width: 100, editable: false },
  { field: "phone", headerName: "전화번호", width: 100, editable: false },
  { field: "foreigner", headerName: "내/외국인", width: 100, editable: false },
  { field: "work_type", headerName: "직업 분류", width: 100, editable: false },
  {
    field: "emp_date",
    headerName: "기관내 채용일자",
    width: 100,
    editable: false,
  },
  {
    field: "emp_type",
    headerName: "전환채용여부",
    width: 100,
    editable: false,
  },
  {
    field: "start_date",
    headerName: "사업참여일",
    width: 100,
    editable: false,
  },
  {
    field: "end_date",
    headerName: "사업철수 (예정)일",
    width: 100,
    editable: false,
  },
  { field: "gender", headerName: "성별", width: 100, editable: false },
  { field: "age", headerName: "나이", width: 100, editable: false },
  { field: "work_rate", headerName: "참여율", width: 100, editable: false },
  { field: "obstacle", headerName: "장애", width: 100, editable: false },
  { field: "pregnancy", headerName: "임신 육아", width: 100, editable: false },
  {
    field: "workless_female",
    headerName: "경력단절여성",
    width: 100,
    editable: false,
  },
  { field: "veterans", headerName: "보훈", width: 100, editable: false },
  {
    field: "multicultural",
    headerName: "다문화가정",
    width: 100,
    editable: false,
  },
  {
    field: "university",
    headerName: "대학생/대학원생",
    width: 100,
    editable: false,
  },
  {
    field: "unemp_mi",
    headerName: "(무직)미취업자",
    width: 100,
    editable: false,
  },
  {
    field: "unemp_sil",
    headerName: "(무직)실직자",
    width: 100,
    editable: false,
  },
  {
    field: "selfemployed",
    headerName: "자영 업자",
    width: 100,
    editable: false,
  },
  { field: "pension", headerName: "국민 연금", width: 100, editable: false },
  { field: "helth", headerName: "건강 보험", width: 100, editable: false },
  { field: "employed", headerName: "고용 보험", width: 100, editable: false },
  {
    field: "interspersed",
    headerName: "산재 보험",
    width: 100,
    editable: false,
  },
  { field: "manager", headerName: "사업 관리", width: 100, editable: false },
  { field: "col", headerName: "수집", width: 100, editable: false },
  { field: "ref", headerName: "정제", width: 100, editable: false },
  { field: "prc", headerName: "가공", width: 100, editable: false },
  { field: "isp", headerName: "품질관리(검수)", width: 100, editable: false },
  {
    field: "etc",
    headerName: "데이터구축관련 기타(기재)",
    width: 100,
    editable: false,
  },
  { field: "aimodel", headerName: "AI모델", width: 100, editable: false },
  {
    field: "appservice",
    headerName: "응용 서비스",
    width: 100,
    editable: false,
  },
  {
    field: "dev",
    headerName: "개발 관련 기타(기재)",
    width: 100,
    editable: false,
  },
  { field: "mon1", headerName: "1월(지급액)", width: 100, editable: false },
  { field: "mon2", headerName: "2월(지급액)", width: 100, editable: false },
  { field: "mon3", headerName: "3월(지급액)", width: 100, editable: false },
  { field: "mon4", headerName: "4월(지급액)", width: 100, editable: false },
  { field: "mon5", headerName: "5월(지급액)", width: 100, editable: false },
  { field: "mon6", headerName: "6월(지급액)", width: 100, editable: false },
  { field: "mon7", headerName: "7월(지급액)", width: 100, editable: false },
  { field: "mon8", headerName: "8월(지급액)", width: 100, editable: false },
  { field: "mon9", headerName: "9월(지급액)", width: 100, editable: false },
  { field: "mon10", headerName: "10월(지급액)", width: 100, editable: false },
  { field: "mon11", headerName: "11월(지급액)", width: 100, editable: false },
  { field: "mon12", headerName: "12월(지급액)", width: 100, editable: false },
  { field: "yaer", headerName: "년도", width: 100, editable: false },
  {
    field: "etc_work_type",
    headerName: "기타직업분류",
    width: 100,
    editable: false,
  },
  {
    field: "emp_type_res",
    headerName: "전환채용사유",
    width: 100,
    editable: false,
  },
  {
    field: "pay_res",
    headerName: "인건비 미계상인 사유",
    width: 100,
    editable: false,
  },
  {
    field: "budget_res",
    headerName: "참여인력 예산 변경사항 기재",
    width: 100,
    editable: false,
  },
];

const theme = createTheme(
  {
    palette: {
      primary: { main: "#1976d2" },
    },
    typography: {
      fontFamily: "Gmarket"
    }
  },
  koKR,
  corekoKR
);

export interface rowDetailType {
  id: number;
  email: string;
  name: string;
  birth: string;
  gender: string;
  phone: string;
  startDate: string;
  roles: string[];
}

export interface pageInfoType {
  current_page: number;
  total_pages: number;
}

const DataTable = () => {
  const [page, setPage] = useState(1);

  const [rows, setRows] = useState([]);
  const [rowDetail, setRowDetail] = useState<rowDetailType>({
    id: 0,
    email: "",
    name: "",
    birth: "",
    gender: "",
    phone: "",
    startDate: "",
    roles: [],
  });
  // api 사용자 정보에서 페이지 정보를 담을 state
  const [pagination, setPagination] = useState<pageInfoType | undefined>(
    undefined
  );

  // 팝업 관리 state
  const [dialogOpen, setDialogOpen] = useState(false);

  const auth = useSelector((state:any)=> state.userInfo.data)
  const email = auth.user.email;

  const getMemberList = async () => {
    var result = await api.get("/cmsList", {
      params: { page: page, email:email },
      withCredentials: true,
    });

    console.log("cms result.data", result.data);

    // table에 넣을 rows 데이터 state에 저장
    setRows(result.data.datas);
    // pagination에 넣을 api data 페이지 정보를 state에 저장
    setPagination(result.data.pagination);
    // console.log("data", result.data.datas);
  };

  useEffect(() => {
    getMemberList();
  }, [page]);

  const goDetail = (event: any) => {
    console.log("event", event.row);

    setRowDetail(event.row);
    setDialogOpen(true);
    console.log("dialogOpen", dialogOpen);
  };

  const goPage = (clickPage: any) => {
    // console.log("clickPage ::: ", clickPage);

    setPage(clickPage);
  };

  function CustomFooter() {
    // console.log("CustomFooter pagination", pagination);
    return (
      <GridFooterContainer sx={{ display: "flex", justifyContent: "center" }}>
        {pagination !== undefined ? (
          <CustomPagination pagination={pagination} goPage={goPage} />
        ) : (
          <></>
        )}
      </GridFooterContainer>
    );
  }

  // console.log(rows);

  return (
    <Box
      sx={{
        width: "100%",
        "& .MuiDataGrid-cell--editing": {
          bgcolor: "rgb(255,215,115, 0.19)",
          color: "#1a3e72",
          "& .MuiInputBase-root": {
            height: "100%",
          },
        },
        "& .Mui-error": {
          bgcolor: (theme) =>
            `rgb(126,10,15, ${theme.palette.mode === "dark" ? 0 : 0.1})`,
          color: (theme) =>
            theme.palette.mode === "dark" ? "#ff4343" : "#750f0f",
        },
      }}
    >
      <React.Fragment>
        <Typography component="h2" variant="h6" color="primary" gutterBottom>사용자 목록</Typography>

        <ThemeProvider theme={theme}>
          <div style={{ height: 400, width: "100%" }}>
            <DataGrid
              editMode="row"
              rows={rows}
              columns={columns}
              onRowDoubleClick={(e) => goDetail(e)}
              checkboxSelection
              pageSize={100}
              components={{ Toolbar: CustomToolbar, Footer: CustomFooter }}
              componentsProps={{
                toolbar: {
                  showQuickFilter: true,
                  quickFilterProps: { debounceMs: 500 },
                },
              }}
              getRowId={(row) => row.idx}
              localeText={koKRGrid}
              experimentalFeatures={{ newEditingApi: true }}
            />
          </div>
        </ThemeProvider>
      </React.Fragment>
      {/* <UserDetail
        dialogOpen={dialogOpen}
        setDialogOpen={setDialogOpen}
        rowDetail={rowDetail}
        setRowDetail={setRowDetail}
        getMemberList={getMemberList()}
      /> */}
    </Box>
  );
};
export default DataTable;
